import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { CircularProgress, FormControl, InputLabel } from '@material-ui/core';
import { withTheme } from '@material-ui/core/styles';
import { validateSignUpData } from '../../utils/validators/validateForm';
import { NotificationManager } from 'react-notifications';
import { ROLE_CUSTOMER } from '../../utils/config/constants';
import { Redirect, withRouter } from 'react-router-dom';
import * as actions from '../../actions';
import { compose } from 'redux';
import { connect } from 'react-redux';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import CustomerVerification from './CustomerVerification';
import { FormattedMessage, injectIntl } from 'react-intl';
class CustomerSignup extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loaderButton: false,
            email: '',
            password: '',
            value: 0,
            nameError: '',
            name: '',
            isVerificationOpen: false,
            closeVerification: false,
            playerId: '',
            countryCode: '+973',
            phone: '',
            phoneError: '',
            countryCodeError: ''
        };
    }
    componentDidMount = async () => {};
    handleClose = () => {
        this.props.closeLoginPopup();
    };
    renderSignupButton = () => {
        if (this.state.loaderButton) {
            return <CircularProgress />;
        } else {
            return (
                <Button
                    className="btn-primary-latest"
                    variant="contained"
                    style={{
                        backgroundColor: this.props.theme.palette.primary.main,
                        color: '#ffffff',
                        fontSize: '16px'
                    }}
                    size="large"
                    onClick={() => this.signupActionCall()}
                >
                    <FormattedMessage id="register" defaultMessage="Register" />
                </Button>
            );
        }
    };

    signupActionCall = () => {
        if (
            validateSignUpData(
                this.state.name,
                null,
                this.state.email,
                this.state.password,
                this.state.countryCode,
                this.state.phone,
                this.handleError
            )
        ) {
            this.setState({ loaderButton: true });
            this.props.signupAction(
                {
                    name: this.state.name,
                    email: this.state.email,
                    password: this.state.password,
                    role: ROLE_CUSTOMER,
                    phone: this.state.phone,
                    countryCode: this.state.countryCode
                },
                this.onDone
            );
        } else {
            NotificationManager.error(
                <FormattedMessage
                    id="Validation Error"
                    defaultMessage="Validation Error"
                />,
                'Oops!'
            );
        }
    };
    handleError = params => {
        this.setState(params);
    };

    onDone = (success, data) => {
        if (success) {
            this.setState({
                loaderButton: false,
                isVerificationOpen: true
            });
        } else {
            this.setState({
                loaderButton: false,
                emailError: data
            });
        }
    };

    render() {
        const {
            passwordError,
            emailError,
            nameError,
            phoneError,
            countryCodeError,
            loaderButton
        } = this.state;
        const { formatMessage } = this.props.intl;
        if (this.state.redirect) {
            this.props.history.push({
                pathname: `/user/profile`
            });
        }

        return (
            <div>
                <form className="form-new" autoComplete="false">
                    <div className="dialog-body">
                        <TextField
                            error={nameError ? true : false}
                            helperText={nameError}
                            className="login-form-textfield"
                            label={formatMessage({
                                id: 'name'
                            })}
                            id="name"
                            fullWidth={true}
                            name="name"
                            type="text"
                            value={this.state.name}
                            onChange={event => {
                                this.setState({
                                    name: event.target.value,
                                    nameError: ''
                                });
                            }}
                            disabled={loaderButton}
                            margin="normal"
                            title="Fill in your name"
                        />
                        <TextField
                            error={emailError ? true : false}
                            helperText={emailError}
                            className="login-form-textfield"
                            label={formatMessage({
                                id: 'email'
                            })}
                            id="email"
                            fullWidth={true}
                            name="email"
                            type="email"
                            value={this.state.email}
                            onChange={event => {
                                this.setState({
                                    email: event.target.value,
                                    emailError: ''
                                });
                            }}
                            disabled={loaderButton}
                            margin="normal"
                            title="Fill in your email"
                        />
                        <TextField
                            error={passwordError ? true : false}
                            helperText={passwordError}
                            className="login-form-textfield"
                            label={formatMessage({
                                id: 'password'
                            })}
                            id="password"
                            fullWidth={true}
                            name="password"
                            type="password"
                            value={this.state.password}
                            onChange={event => {
                                this.setState({
                                    password: event.target.value,
                                    passwordError: ''
                                });
                            }}
                            disabled={loaderButton}
                            margin="normal"
                            title="Enter your password, try one uppercase, lowercase, special characters for better password protection"
                        />
                        {/* <p>
                            Password must contain an Alphabet, a number and a
                            special character.
                        </p> */}
                    </div>{' '}
                    <div className="row mb-3">
                        <div className="col-md-4 col-5">
                            <FormControl
                                className={'login-form-textfield phone-field'}
                                error={countryCodeError ? true : false}
                            >
                                <InputLabel shrink>
                                    <FormattedMessage
                                        id="countryCode"
                                        defaultMessage="Country Code"
                                    />
                                </InputLabel>

                                <PhoneInput
                                    placeholder="Enter"
                                    value={this.state.countryCode}
                                    onChange={value =>
                                        this.setState({
                                            countryCode: value
                                        })
                                    }
                                    title="Enter your country code"
                                />
                            </FormControl>
                        </div>
                        <div className="col-md-7 col-7 pl-0 pl-md-3 col-width-7">
                            <TextField
                                error={phoneError ? true : false}
                                helperText={phoneError}
                                className="login-form-textfield"
                                label="Mobile number without country code"
                                placeholder="Mobile number without country code"
                                id="phone"
                                fullWidth={true}
                                name="phone"
                                type="text"
                                value={this.state.phone}
                                onChange={event => {
                                    this.setState({
                                        phone: event.target.value,
                                        phoneError: ''
                                    });
                                }}
                                disabled={this.state.loaderButton}
                                margin="normal"
                                title="Enter your phone number"
                            />
                        </div>
                    </div>
                    <p>Hint: Please add + before country code</p>
                    <div className="sign-new-btn text-left">
                        {this.renderSignupButton()}
                    </div>
                </form>
                <CustomerVerification
                    email={this.state.email}
                    open={this.state.isVerificationOpen}
                    close={this.closeVerification}
                />
            </div>
        );
    }
}
const composedComponent = compose(withTheme(), connect(null, actions));
export default composedComponent(injectIntl(withRouter(CustomerSignup)));



// WEBPACK FOOTER //
// ./src/components/Customer/CustomerSignup.jsx